import { watch } from "vue";
import { FilterModel } from "@Apps/Search/Src/Models/FilterModel";






export const setupFilterWatch = (filter: FilterModel, action: () => void,
    excludeLocation: boolean, locationAction: null | (() => void),
    excludeOrderBy: boolean, orderByAction: null | (() => void),

) => {

    if (!excludeLocation && !excludeOrderBy) {

        watch(filter, () => {

            action();

        }, {
            deep: true,
            flush: 'post'
        });
    } else {

        // we have to setup a watch for each property, except excluded versions, 
        // which get a seperate watch if an action is provided.

        const exclude = [] as Array<string>;

        if (excludeLocation) {
            exclude.push('location');
        }
        if (excludeOrderBy) {
            exclude.push('orderBy');
        }

        const propertiesToWatch = Object.keys(filter).filter(prop => !exclude.includes(prop))

        for (const prop of propertiesToWatch) {
            watch(
                () => filter[prop as keyof FilterModel],
                (newValue, oldValue) => {
                    action()
                },
                { deep: true }
            )
        }

        if (locationAction != null) {
            watch(
                () => filter.location,
                (newValue, oldValue) => {
                    if (locationAction) {
                        locationAction()
                    }
                },
                { deep: true }
            )
        }

        if (orderByAction != null) {
            watch(
                () => filter.orderBy,
                (newValue, oldValue) => {
                    if (orderByAction) {
                        orderByAction()
                    }
                },
                { deep: true }
            )
        }
    }

};